import React from 'react';
import './Economics.css';

import BottomBanner from './BottomBanner';

const Economics = () => {
  return (
    <>
    <div className="page-container">
      <div className="page-header">
        <h1>Economics</h1>
        <p className="page-subtitle">Latest economic news, analysis, and insights</p>
      </div>
      
      <div className="page-content">
        <div className="content-grid">
          <a href="/article/global-economic-outlook-resilience" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&h=400&fit=crop" alt="Economic indicators" />
            </div>
            <div className="article-content">
              
              <h2>Global Economic Outlook Shows Resilience</h2>
              <p>Economic indicators suggest continued growth despite challenges in key markets around the world.</p>
              <span className="article-meta">2 hours ago</span>
            </div>
          </a>

          <a href="/article/central-banks-policy-shifts" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&h=400&fit=crop" alt="Financial markets" />
            </div>
            <div className="article-content">
              
              <h2>Central Banks Signal Policy Shifts</h2>
              <p>Major central banks around the world are adjusting their monetary policies in response to changing economic conditions.</p>
              <span className="article-meta">4 hours ago</span>
            </div>
          </a>

          <a href="/article/inflation-trends-moderation" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop" alt="Economic data" />
            </div>
            <div className="article-content">
              
              <h2>Inflation Trends Show Moderation</h2>
              <p>Latest inflation data reveals cooling pressures across major economies, providing relief to policymakers.</p>
              <span className="article-meta">6 hours ago</span>
            </div>
          </a>
        </div>
      </div>
    </div>

     {/*  Bottom Subscription Banner */}
       <BottomBanner />
      </>
  );
};

export default Economics;
